import React from 'react'
import { 
  Badge,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
} from 'reactstrap'
import { SetsList, SetsSearchBar, SetsAdd } from '../ManageSetsComponents'

/*

    <SetsCard 
      setSearch={props.setSearch} 
      handleSetSearchChange={props.handleSetSearchChange}
      addSetName={props.addSetName}
      handleAddSetNameChange={props.handleAddSetNameChange}
      handleSubmitAddSet={props.handleSubmitAddSet}
      searchedSets={props.searchedSets}
      activeSet={props.activeSet}
      handleDeleteSet={props.handleDeleteSet}
    />

*/

export default function SetsCard(props) {
  return (
      <Col md='12' lg='4' xl='3'>
        <Card>
          <CardHeader>Sets</CardHeader>
          <CardBody>
            <SetsSearchBar setSearch={props.setSearch} handleSetSearchChange={props.handleSetSearchChange} />
            <SetsAdd 
              addSetName={props.addSetName} 
              handleAddSetNameChange={props.handleAddSetNameChange} 
              handleSubmitAddSet={props.handleSubmitAddSet}  
            />
            <SetsList 
              searchedSets={props.searchedSets}
              activeSet={props.activeSet}
              handleDeleteSet={props.handleDeleteSet}
              locationSearch={props.locationSearch}
            />
          </CardBody>
        </Card>
      </Col>
  )
}


// WEBPACK FOOTER //
// ./src/components/Content/ManageSetsComponents/SetsCard.js